export const AnomalyChip = ({ value }: { value: number }) => {
  return (
    <p className="flex justify-center opacity-90">
      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#dde0e9] dark:bg-[#404040]">
        {value}
      </span>
    </p>
  );
};
